import WidgetBox from "components/elements/WidgetBox/widget-box";
import { PropertyFieldView } from "./default/components/property-fields";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { Text } from "@chakra-ui/react";
import { PropertyFieldsAmplend } from "./amplend/property-fields-amplend";

interface PropertyDetailsProps {
  propertyId: number;
}

export function PropertyDetails({ propertyId }: PropertyDetailsProps) {
  const { user } = useTenant();

  const propertyTemplateName =
    user?.company?.company_configurations?.[0]?.field_controls?.property_detail_template ||
    "default";

  const renderContent = () => {
    if (propertyTemplateName === "default") {
      return <PropertyFieldView propertyId={propertyId} />;
    }

    if (propertyTemplateName === "amplend") {
      return <PropertyFieldsAmplend propertyId={propertyId} />;
    }

    return <Text>Property template not found 222</Text>;
  };

  return <WidgetBox>{renderContent()}</WidgetBox>;
}
